module.exports = __webpack_public_path__ + "media/corporate-image/hyakkaten-6defc9112522bc2df2eb7aec8a5e9dbc.jpg";